import { render, staticRenderFns } from "./tab_medsos.vue?vue&type=template&id=95dce466"
import script from "./tab_medsos.vue?vue&type=script&lang=js"
export * from "./tab_medsos.vue?vue&type=script&lang=js"
import style0 from "./tab_medsos.vue?vue&type=style&index=0&id=95dce466&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports